import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { signOut } from 'aws-amplify/auth';

const Header: React.FC = () => {
  const navigate = useNavigate();

  // async function logOut() {
  //   try {
  //     await signOut();
  //     logUser(false);
  //     localStorage.removeItem('amplify-redirected-from-hosted-ui');
  //     localStorage.clear();
  //     navigate('/');
  //   } catch (e) {}
  // }

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        backgroundColor: '#FFBF23',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        style={{
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={() => {
            navigate('/');
          }}
        >
          <div style={{ height: '40px', maxWidth: '120px', overflow: 'hidden' }}>
            <img
              src='/Asset23@3x.png'
              alt='logo'
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                height: 'auto',
                width: 'auto',
              }}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
